var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridBase',{class:[_vm.type, _vm.dark ? 'dark' :''],attrs:{"title-block":"","dark":_vm.dark}},[_c('div',{attrs:{"title-block-content":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }